import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/GENERAL/iwwportsgeneral";
import TODIS_FORM_DESC from "./form/GENERAL/description";
import TODIS_FORM_TENCOMPLIANCE from "./form/NSEAPORT/seaporttencompliance";
import TODIS_FORM_ELEGPROJECT from "./form/GENERAL/seaportentproject";
import TODIS_FORM_INDICATORS from "./form/NSEAPORT/indicators";
import TODIS_FORM_PERFOMANCE_INDICADOR from "./form/GENERAL/perfomanceindicador";
import TODIS_FORM_STATUS from "./form/LSEAPORT/status";
import { TODIS_FORM_DSC, TODIS_FORM_FIELD_YES_NO } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";
import TODIS_FORM_GENERAL_SEAPORT from "./form/LSEAPORT/general";
import TODIS_FORM_LIVE_FUND from "./form/LSEAPORT/lFundingsources";
import TODIS_TECH_DOCU from "./form/LSEAPORT/lTechnicalDocumentation";
import TODIS_TIMELINE from "./form/GENERAL/lTimeline";
import TODIS_FORM_OTHER_SEAPORTP from "./form/LSEAPORT/other";
import { loadModules } from 'esri-loader';


const TODIS_FORM = ({ errors, touched, status, setFieldValue, values }) => {
    const [statusTabDisabled, setStatusTabDisabled] = useState(true)

    useEffect(() => {
        try {
            const [Query, query] = loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/25";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `live_seaports_proj_id=${values.liveSeaportsProjId}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            const results = query.executeQueryJSON(queryUrl, queryObject);

            if (results.features.length > 0) {
                setStatusTabDisabled(false);
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }

    })
    const generalTooltip = (
        <Tooltip id="general-tooltip">
            General data
        </Tooltip>
    );

    const descriptionTooltip = (
        <Tooltip id="description-tooltip">
            Project description
        </Tooltip>
    )

    const statusTooltip = (
        <Tooltip id="status-tooltip">
            Project implementation status
        </Tooltip>
    )

    const tentIndicatorsTooltip = (
        <Tooltip id="tent-indicators-tooltip">
            The TEN-T indicators the project will be addressing
        </Tooltip>
    )

    const tentComplianceTooltip = (
        <Tooltip id="tent-compliance-tooltip">
            Current compliance of the Seaport section the project is related to
        </Tooltip>
    )

    const perfIndicatorsTooltip = (
        <Tooltip id="perfIndicators-tooltip">
            Project's compliance indicators
        </Tooltip >
    )

    const fundSourcesTooltip = (
        <Tooltip id="fundSources-tooltip">
            Project's funding sources
        </Tooltip>
    )

    const techDocuTooltip = (
        <Tooltip id="techDocu-tooltip">
            Project's technical documentation
        </Tooltip>
    )

    const otherTootltip = (
        <Tooltip id="other-tooltip">
            Other parameters related data
        </Tooltip>
    );

    return (
        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">

            <Tab eventKey="General" title={
                <OverlayTrigger placement="top" overlay={generalTooltip}>
                    <div>General</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL_SEAPORT errors={errors} touched={touched} disabled={status} TypeForm="" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status} />
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="lDescritpion" title={
                <OverlayTrigger placement="top" overlay={descriptionTooltip}>
                    <div>Description</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_DESC errors={errors} touched={touched} disabled={status} TypeForm="seaportsLivePmDescDTO" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="seaportsLivePmDescDTO.remarks" label="Remarks" name="seaportsLivePmDescDTO.remarks" disabled={status} />
                            {errors.seaportsLivePmDescDTO && errors.seaportsLivePmDescDTO.remarks && touched.seaportsLivePmDescDTO && touched.seaportsLivePmDescDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmDescDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>

            <Tab eventKey="lStatus" title={
                <OverlayTrigger placement="top" overlay={statusTooltip}>
                    <div>Status</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_STATUS errors={errors} touched={touched} disabled={status} TypeForm="seaportsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lFund" title={
                <OverlayTrigger placement="top" overlay={fundSourcesTooltip}>
                    <div>Funding sources</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_LIVE_FUND errors={errors} touched={touched} disabled={status} TypeForm="seaportsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lTechDocu" title={
                <OverlayTrigger placement="top" overlay={techDocuTooltip}>
                    <div>Technical documentation</div>
                </OverlayTrigger>
            }>
                <TODIS_TECH_DOCU errors={errors} touched={touched} disabled={status} TypeForm="seaportsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lTimeline" title="Timeline">
                <TODIS_TIMELINE errors={errors} touched={touched} disabled={status} TypeForm="seaportsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lElegibilityProject" title={
                <OverlayTrigger placement="bottom" overlay={tentIndicatorsTooltip}>
                    <div>Targeted TEN-T indicators</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_ELEGPROJECT errors={errors} touched={touched} disabled={status} TypeForm="seaportsLivePmEligiTentDTO" setFieldValue={setFieldValue} values={values} />
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsLivePmEligiTentDTO.vtmisDeploy" label="VTMIS Deployment" name="seaportsLivePmEligiTentDTO.vtmisDeploy" disabled={status} />
                            {errors.seaportsLivePmEligiTentDTO && errors.seaportsLivePmEligiTentDTO.vtmisDeploy && touched.seaportsLivePmEligiTentDTO && touched.seaportsLivePmEligiTentDTO.vtmisDeploy ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmEligiTentDTO.vtmisDeploy}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsLivePmEligiTentDTO.iwwCemtConn" label="IWW/ CEMT Connection" name="seaportsLivePmEligiTentDTO.iwwCemtConn" disabled={status} />
                            {errors.seaportsLivePmEligiTentDTO && errors.seaportsLivePmEligiTentDTO.iwwCemtConn && touched.seaportsLivePmEligiTentDTO && touched.seaportsLivePmEligiTentDTO.iwwCemtConn ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmEligiTentDTO.iwwCemtConn}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsLivePmEligiTentDTO.wasteFacilities" label="Waste facilities" name="seaportsLivePmEligiTentDTO.wasteFacilities" disabled={status} />
                            {errors.seaportsLivePmEligiTentDTO && errors.seaportsLivePmEligiTentDTO.wasteFacilities && touched.seaportsLivePmEligiTentDTO && touched.seaportsLivePmEligiTentDTO.wasteFacilities ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmEligiTentDTO.wasteFacilities}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsLivePmEligiTentDTO.intermodalUnitsHandling" label="Intermodal units handling" name="seaportsLivePmEligiTentDTO.intermodalUnitsHandling" disabled={status} />
                            {errors.seaportsLivePmEligiTentDTO && errors.seaportsLivePmEligiTentDTO.intermodalUnitsHandling && touched.seaportsLivePmEligiTentDTO && touched.seaportsLivePmEligiTentDTO.intermodalUnitsHandling ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmEligiTentDTO.intermodalUnitsHandling}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsLivePmEligiTentDTO.safeSeaNet" label="SafeSeaNet" name="seaportsLivePmEligiTentDTO.safeSeaNet" disabled={status} />
                            {errors.seaportsLivePmEligiTentDTO && errors.seaportsLivePmEligiTentDTO.safeSeaNet && touched.seaportsLivePmEligiTentDTO && touched.seaportsLivePmEligiTentDTO.safeSeaNet ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmEligiTentDTO.safeSeaNet}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsLivePmEligiTentDTO.maritimeNSW" label="MaritimeNSW" name="seaportsLivePmEligiTentDTO.maritimeNSW" disabled={status} />
                            {errors.seaportsLivePmEligiTentDTO && errors.seaportsLivePmEligiTentDTO.maritimeNSW && touched.seaportsLivePmEligiTentDTO && touched.seaportsLivePmEligiTentDTO.maritimeNSW ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmEligiTentDTO.maritimeNSW}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsLivePmEligiTentDTO.alternativeFuelsElectricity" label="Alternative Fuels Electricity" name="seaportsLivePmEligiTentDTO.alternativeFuelsElectricity" disabled={status}/>
                            {errors.seaportsLivePmEligiTentDTO && errors.seaportsLivePmEligiTentDTO.alternativeFuelsElectricity && touched.seaportsLivePmEligiTentDTO && touched.seaportsLivePmEligiTentDTO.alternativeFuelsElectricity ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmEligiTentDTO.alternativeFuelsElectricity}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsLivePmEligiTentDTO.alternativeFuelsMethane" label="Alternative Fuels Methane" name="seaportsLivePmEligiTentDTO.alternativeFuelsMethane" disabled={status}/>
                            {errors.seaportsLivePmEligiTentDTO && errors.seaportsLivePmEligiTentDTO.alternativeFuelsMethane && touched.seaportsLivePmEligiTentDTO && touched.seaportsLivePmEligiTentDTO.alternativeFuelsMethane ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmEligiTentDTO.alternativeFuelsMethane}</div>) : null}
                        </Col>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="seaportsLivePmEligiTentDTO.remarks" label="Remarks" name="seaportsLivePmEligiTentDTO.remarks" disabled={status} />
                            {errors.seaportsLivePmEligiTentDTO && errors.seaportsLivePmEligiTentDTO.remarks && touched.seaportsLivePmEligiTentDTO && touched.seaportsLivePmEligiTentDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmEligiTentDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="lTenCompliance" title={
                <OverlayTrigger placement="bottom" overlay={tentComplianceTooltip}>
                    <div>TEN-T compliance of the related Seaport</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} TypeForm="seaportsLivePmTentcompDTO" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="seaportsLivePmTentcompDTO.remarks" label="Remarks" name="seaportsLivePmTentcompDTO.remarks" disabled={status} />
                            {errors.seaportsLivePmTentcompDTO && errors.seaportsLivePmTentcompDTO.remarks && touched.seaportsLivePmTentcompDTO && touched.seaportsLivePmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {/* <Tab eventKey="perfomanceindicador" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_PERFOMANCE_INDICADOR errors={errors} touched={touched} disabled={status} TypeForm="seaportsLivePmPiDTO"  Name1="forecastPortTraffic" Name2="actualPortTraffic" Label1="Port traffic - forecasted" Label2="Port traffic - actual"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="seaportsLivePmPiDTO.remarks" label="Remarks" name="seaportsLivePmPiDTO.remarks" disabled={status}/>
                            {errors.seaportsLivePmPiDTO && errors.seaportsLivePmPiDTO.remarks && touched.seaportsLivePmPiDTO && touched.seaportsLivePmPiDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmPiDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab> */}
            <Tab eventKey="lIndicators" title={
                <OverlayTrigger placement="bottom" overlay={perfIndicatorsTooltip}>
                    <div>Performance indicators</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_INDICATORS errors={errors} touched={touched} disabled={status} TypeForm="seaportsLivePmIndicatorsDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="seaportsLivePmIndicatorsDTO.remarks" label="Remarks" name="seaportsLivePmIndicatorsDTO.remarks" disabled={status} />
                            {errors.seaportsLivePmIndicatorsDTO && errors.seaportsLivePmIndicatorsDTO.remarks && touched.seaportsLivePmIndicatorsDTO && touched.seaportsLivePmIndicatorsDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsLivePmIndicatorsDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {statusTabDisabled ? null :
                <Tab eventKey="Other" title={
                    <OverlayTrigger placement="bottom" overlay={otherTootltip}>
                        <div>Others</div>
                    </OverlayTrigger>
                }>
                    <Container>
                        <Row>
                            <TODIS_FORM_OTHER_SEAPORTP errors={errors} touched={touched} disabled={status} TypeForm="seaportsLiveOtherDTO" values={values} />
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}
export default TODIS_FORM;